export default function shortenString (string, charactersLength) {
  return string.length > charactersLength ? string.substring(0, charactersLength) + '...' : string
}
